import { gql } from '@apollo/client'

export const saveDraftFeedbackMutation = gql`
  mutation SaveDraftFeedback($saveDraftFeedbackInput: SaveDraftFeedbackInput!) {
    saveDraftFeedback(saveDraftFeedbackInput: $saveDraftFeedbackInput) {
      id
    }
  }
`
